import { render } from "./WorkLocationsManagement.vue?vue&type=template&id=7043a6da&scoped=true"
import script from "./WorkLocationsManagement.vue?vue&type=script&lang=js"
export * from "./WorkLocationsManagement.vue?vue&type=script&lang=js"

import "./WorkLocationsManagement.vue?vue&type=style&index=0&id=7043a6da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7043a6da"]])

export default __exports__